// extracted by mini-css-extract-plugin
export default {"header":"header_header__paCdI","header__cell":"header_header__cell__7a+3a"};